import React from 'react';
import PageMeta from '../../components/PageMeta';

export default function InfoPageLayout({
  title,
  description,
  heading,
  body,
  subtitle = null,
  children = null,
  containerClassName = '',
  headingClassName = '',
  bodyClassName = '',
}) {
  const canonicalUrl =
    typeof window !== 'undefined'
      ? window.location.href
      : `https://lilycove.io/${heading.toLowerCase()}`;

  const resolvedContainerClassName = `mx-auto max-w-3xl rounded-2xl border border-purple/30 bg-dark/60 p-8 md:p-10 ${containerClassName}`.trim();
  const resolvedHeadingClassName = `mb-4 text-3xl font-medium text-purple ${headingClassName}`.trim();
  const resolvedBodyClassName = `leading-relaxed text-cream/85 ${bodyClassName}`.trim();

  return (
    <section className="py-16">
      <PageMeta title={title} description={description} url={canonicalUrl} />
      <div className={resolvedContainerClassName}>
        <h1 className={resolvedHeadingClassName}>{heading}</h1>
        {subtitle ? <p className="mb-6 text-sm text-cream/70">{subtitle}</p> : null}
        {children ? children : <p className={resolvedBodyClassName}>{body}</p>}
      </div>
    </section>
  );
}
